var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8141",
    "data-name": "Group 8141",
    transform: "translate(-363 -136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    transform: "translate(363 136)",
    fill: "#569dfa",
    stroke: "#5aa2fb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 23,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_8665646_phone_communication_icon",
    "data-name": "8665646_phone_communication_icon",
    d: "M15.268,11.553l-.694,3.011a.928.928,0,0,1-.91.723A13.679,13.679,0,0,1,0,1.622.928.928,0,0,1,.723.713L3.734.018A.937.937,0,0,1,4.8.559L6.192,3.8a.935.935,0,0,1-.268,1.089L4.316,6.18a10.443,10.443,0,0,0,4.764,4.764L10.4,9.337a.929.929,0,0,1,1.089-.268l3.241,1.389A1.019,1.019,0,0,1,15.268,11.553Z",
    transform: "translate(370.355 140.359)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6e25dc12c8b45b4a90c95e304b9832d6.svg";
export { ForwardRef as ReactComponent };